import { Controller } from "@hotwired/stimulus"

// The site header's menu on a phone or a tablet (application/_header): a native dialog, so Esc, focus and the
// page behind it are the browser's. A tap outside the sheet closes it, and so does following a link, so a jump to
// a part of the home page lands with the menu out of the way.
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  follow(event) {
    if (event.target.closest("a")) this.close()
  }
}
